import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SAP_CTA_ON_PETITION_SHOW = createFcmDetails('sap_cta_on_petition_show', {
	owner: 'supporters pack',
	context: 'petition page',
	description:
		'Indicates whether to display a SAP CTA button under the petition description, for users that have signed the petition.',
	import: false,
});
